// Apparence de l'app (Idries : « ajoute le choix sombre / clair dans Moi ») : Automatique (le réglage du téléphone),
// Clair ou Sombre, retenu par l'appareil. Les styles sombres de l'app sont écrits en @media (prefers-color-scheme: dark) :
// pour forcer un choix, on réécrit le média de ces règles (toujours vrai, ou jamais), y compris dans les feuilles
// chargées plus tard (écrans à la demande). Automatique remet les médias d'origine.
export type Appearance = 'auto' | 'light' | 'dark';
const KEY = 'arceau.appearance';
const DARK = '(prefers-color-scheme: dark)';
const ALWAYS = '(min-width: 0px)', NEVER = '(max-width: 0px)';
const original = new WeakMap<CSSMediaRule, string>();
let mode: Appearance = 'auto';

export function readAppearance(): Appearance {
  try { const v = localStorage.getItem(KEY); return v === 'light' || v === 'dark' ? v : 'auto'; } catch { return 'auto'; }
}

function rewrite(rules: CSSRuleList): void {
  for (const r of Array.from(rules)) {
    if (r instanceof CSSMediaRule) {
      const base = original.get(r) ?? r.media.mediaText;
      if (base.includes('prefers-color-scheme: dark')) {
        if (!original.has(r)) original.set(r, base);
        const want = mode === 'auto' ? base : base.split(DARK).join(mode === 'dark' ? ALWAYS : NEVER);
        if (r.media.mediaText !== want) r.media.mediaText = want;
      }
    }
    if ('cssRules' in r && (r as CSSGroupingRule).cssRules) rewrite((r as CSSGroupingRule).cssRules);
  }
}

function applyAll(): void {
  for (const s of Array.from(document.styleSheets)) {
    try { rewrite(s.cssRules); } catch { /* feuille d'une autre origine : rien à réécrire */ }
  }
  document.documentElement.style.colorScheme = mode === 'auto' ? '' : mode;
}

let watching = false;
/** Une fois au démarrage, puis à chaque choix. */
export function applyAppearance(next: Appearance = readAppearance()): void {
  mode = next;
  applyAll();
  if (watching) return;
  watching = true;
  // Une feuille encore en chargement au démarrage (lien de la version en ligne) : réécrite dès qu'elle est là.
  for (const l of Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'))) {
    if (!l.sheet) l.addEventListener('load', applyAll, { once: true });
  }
  // Les écrans chargés à la demande ajoutent leurs feuilles : on les réécrit dès qu'elles sont là.
  new MutationObserver(muts => {
    for (const m of muts) for (const n of Array.from(m.addedNodes)) {
      if (n instanceof HTMLStyleElement) applyAll();
      else if (n instanceof HTMLLinkElement && n.rel === 'stylesheet') n.addEventListener('load', applyAll, { once: true });
    }
  }).observe(document.head, { childList: true });
}

export function setAppearance(next: Appearance): void {
  try { if (next === 'auto') localStorage.removeItem(KEY); else localStorage.setItem(KEY, next); } catch { /* pour la visite */ }
  applyAppearance(next);
}

export const APPEARANCE_LABEL: Record<Appearance, string> = { auto: 'Automatique', light: 'Clair', dark: 'Sombre' };
